import type { Locale } from "@commerce-frontend/i18n/types";
import { graphql } from "@commerce-frontend/types";
import { cn } from "@commerce-frontend/ui/helpers/styles";
import type { ResultOf } from "@graphql-typed-document-node/core";
import { cva } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { RenderBlock } from "../RenderBlock/RenderBlock";

export const ColumnBlockFragment = graphql(/* GraphQL */ `
	fragment ColumnBlockFragment on ColumnBlock {
		...DividerFragment
		...IframeFragment
		...ImageFragment
		...RichTextFragment
		...ButtonsFragment
		...BlockQuoteFragment
		...TableFragment
		...NewsletterCTAFragment
		...CookieDeclarationFragment
		...VideoFragment
		...FAQItemListFragment
	}
`);

type Props = {
	data: ResultOf<typeof ColumnBlockFragment>[];
	locale: Locale;
} & HTMLAttributes<HTMLDivElement>;

export const Column = ({ data, locale, className, ...attributes }: Props) => (
	<div {...attributes} className={cn("flex flex-1 flex-col gap-xl max-lg:w-full", className)}>
		{data.map((block) => {
			if (!("__typename" in block)) {
				return null;
			}

			return <RenderBlock key={block.id} block={block} locale={locale} wrapContent={false} />;
		})}
	</div>
);

export const columnVariants = cva("flex flex-col gap-xl md:gap-3xl lg:flex-row lg:gap-4xl", {
	variants: {
		alignment: {
			top: "items-start",
			center: "items-center",
			bottom: "items-end",
		},
	},
	defaultVariants: {
		alignment: "top",
	},
});
